
import BuilderInputs from 'components/builder/builder-inputs.vue'

export default {
  components: {
    BuilderInputs
  },
  props: {
    store: {type: Object, required: true}
  },
  emits: ['update'],
  data() {
    return {
      schema: [
        {
          field: 'apollo_tool_enabled',
          type: 'checkbox',
          label: 'Enable Apollo tool'
        },
        {
          field: 'persona_news_enabled',
          type: 'checkbox',
          label: 'Include news section in persona snapshots (applies to new snapshots only)'
        },
        {
          field: 'artifacts_enabled',
          type: 'checkbox',
          label: 'Enable Artifacts'
        },
        {
          field: 'pulse_context',
          type: 'textarea',
          title: 'Pulse Context',
          maxlength: 16384,
          minlenght: 0,
          rows: 10
        },
        {
          field: 'chat_context',
          type: 'textarea',
          title: 'Chat Context',
          maxlength: 16384,
          minlenght: 0,
          rows: 10
        }
      ]
    }
  }
}
